import { BaseLayer } from '.'
import type { FeatureCollection, Point } from 'geojson'
import { Subscriber } from 'cesium-extends'
import { Billboard, BillboardCollection, Cartesian3, NearFarScalar } from 'cesium'
import cameraIMG from '@/assets/cam.png?url'
import { apiFzu } from '@/apiFzu'
import type { Camera as CameraVo } from '@/apiFzu/ApiFzu'
export class CameraLayer extends BaseLayer<{
  click(p: Omit<CameraVo, 'geom'>): void
}> {
  layername: string = '摄像头'
  key: string = 'camera'
  private billboards?: BillboardCollection
  private billboardsData = new Map<number, Omit<CameraVo, 'geom'>>()
  constructor() {
    super()
    this.once('mounted', (viewer) => {
      this._subscriber = new Subscriber(viewer, { pickResult: { enable: true } })
    })
  }
  async render() {
    const geojson = await this.loadGeojson()
    if (this.billboards) {
      this.layer.primitiveCollection.remove(this.billboards)
      this.billboards.destroy()
      this.billboards = undefined
      this.billboardsData.clear()
    }
    this.billboards = new BillboardCollection()
    this.layer.primitiveCollection.add(this.billboards)
    geojson.features.forEach((feature) => {
      const position = Cartesian3.fromDegrees(
        feature.geometry.coordinates[0],
        feature.geometry.coordinates[1]
      )
      this.billboards?.add({
        position: position,
        id: feature.id,
        image: cameraIMG,
        width: 24,
        height: 24,
        disableDepthTestDistance: 3000000,
        scaleByDistance: new NearFarScalar(50, 5, 5000, 1),
        // distanceDisplayCondition: new DistanceDisplayCondition(0, 3000000),
      })
      this.billboardsData.set(feature.id as number, feature.properties)
    })
    this._subscriber?.addExternal((_movement, res) => {
      if (this.billboards === res?.collection) {
        const primitive = res.primitive as Billboard
        if (!primitive) return
        const data = this.billboardsData.get(primitive.id)
        data && this.emit('click', data)
      }
    }, 'LEFT_CLICK')
    // this._subscriber?.add(
    //   this.datasource.entities.values,
    //   (_e, substance) => {
    //     const viewer = this._viewer
    //     if (!viewer || !substance) return
    //     const position = substance.position?.getValue()
    //     if (!position) return
    //     const cartographic = Cartographic.fromCartesian(position)
    //     this.popupCtrl.popup({
    //       viewer,
    //       id: substance.id,
    //       Com: DevPopup,
    //       lnglat: [cartographic.longitude, cartographic.latitude].map(CMath.toDegrees) as [
    //         number,
    //         number,
    //       ],
    //       properties: substance.properties?.getValue(),
    //     })
    //   },
    //   'LEFT_CLICK'
    // )
  }
  private async loadGeojson() {
    const res = await apiFzu.camera.cameraControllerGetCameraList()
    const featureCollection: FeatureCollection<Point, Omit<CameraVo, 'geom'>> = {
      type: 'FeatureCollection',
      features: [],
    }
    res.data.forEach((el) => {
      const { geom, ...properties } = el
      featureCollection!.features.push({
        type: 'Feature',
        id: properties.id,
        geometry: geom,
        properties: { ...properties },
      })
    })
    return featureCollection
  }
}
